<template>
  <el-main>
    <div id="redirectToETohyo">
      <form
        ref="epost"
        name="epost"
        id="epost"
        method="POST"
        action="https://zm.etohyo.com/cmn_sso_online.aspx"
      >
        <input
          type="hidden"
          name="UserID"
          :value="md5hex(currentUser.loginID)"
        />
      </form>
    </div>
  </el-main>
</template>

<script>
import store from "../store";

export default {
  name: "RedirectToETohyo",
  data() {
    return {
      successful: false,
    };
  },
  computed: {
    loggedIn() {
      return store.state.auth.status.loggedIn;
    },
  },
  async mounted() {
    console.log(this.currentUser);
    this.$refs.epost.submit();
  },
};
</script>

<style></style>
